'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Html(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M73.344 534.496a31.552 31.552 0 0 1 0-44.864v-0.064l224.384-224.192a31.712 31.712 0 1 1 44.896 44.864L140.672 512l201.952 201.824a31.68 31.68 0 0 1 0.064 44.928 31.936 31.936 0 0 1-44.96-0.064l-224.352-224.192h-0.032z m877.312 0v0.032l-224.384 224.192a31.936 31.936 0 0 1-44.96 0.064 31.68 31.68 0 0 1 0.064-44.928l201.952-201.824-201.952-201.792a31.712 31.712 0 1 1 44.896-44.864l224.352 224.192h0.032v0.032a31.552 31.552 0 0 1 0 44.864v0.032z' })
  );
}
Html.displayName = 'Html';

module.exports = Html;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/html.js
// module id = 180
// module chunks = 0